function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { useIsomorphicLayoutEffect } from '../shared/use-isomorphic-layout-effect';
import { classNames, getExtraAttrs } from '../shared/utils';
import { colorClasses } from '../shared/mixins';
import RoutableModals from './routable-modals';
import { f7init, f7 } from '../shared/f7';



var App = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      style = props.style,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["className", "style", "children"]);

  var extraAttrs = getExtraAttrs(props);
  var params = rest;
  var elRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      el: elRef.current
    };
  });
  var classes = classNames(className, 'framework7-root', colorClasses(props)); // eslint-disable-next-line

  if (!f7 || typeof window === 'undefined') {
    f7init(elRef.current, params, false);
  }

  useIsomorphicLayoutEffect(function () {
    var parentEl = elRef.current && elRef.current.parentNode;
    /* eslint-disable no-restricted-globals */

    if (typeof document !== 'undefined' && parentEl && parentEl !== document.body && parentEl.parentNode === document.body) {
      parentEl.style.height = '100%';
    }
    /* eslint-enable no-restricted-globals */


    if (f7) {
      f7.init(elRef.current);
      return;
    }

    f7init(elRef.current, params, true);
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: "framework7-root",
    style: style,
    className: classes,
    ref: elRef
  }, extraAttrs), children, /*#__PURE__*/React.createElement(RoutableModals, null));
});
App.displayName = 'f7-app';
export default App;